import { Page } from "@/models/page-models/Page";

export const LoadingManifestLoadingManifestId: Page = {
  "path": "loading-manifest/:loadingManifestId",
  "name": "Loading Manifest",
  "props": {
    "data": {
      "title": "Loading Manifest",
      "printable": "{{fetchedData.loadingManifest.data.invoice}}",
      "url": "loading-manifest/:loadingManifestId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestDetails",
                  "variable": "fetchedData.loadingManifest.data",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.orders}})",
                  "config": {
                    "customerDetailsVariable": "formData.customerDetails.data",
                    "deliveryAddressRef": "orders.0.order.deliveryLocation"
                  }
                }
              ]
            },
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestDetails",
                  "variable": "fetchedData.loadingManifest.data",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.callOffs}})",
                  "config": {
                    "customerDetailsVariable": "formData.customerDetails.data",
                    "deliveryAddressRef": "callOffs.0.callOff.deliveryLocation"
                  }
                }
              ]
            },
            {
              "name": "2a",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Order Table",
                  "disabled": "FALSE",
                  "items": "fetchedData.loadingManifest.data.orders",
                  "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.orders}})",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.loadingManifest.data.orders}}))"
                    },
                    {
                      "value": "__item.order._id",
                      "text": "Order #\\n# حزمة",
                      "type": "url",
                      "url": "/order/{{__item.order._id}}"
                    },
                    {
                      "value": "__item.factoryTicket.order.product",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productInvoiceName,fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}}),{{__item.lineNumber}},{{__item.itemNumber}})"
                    },
                    {
                      "value": "__item.quantityA",
                      "text": "Quantity A\\nA الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item.fg.0}},fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.order.product.packingMode.0.unit1}}), ,{{__item.order.product.packingMode.0.unit1}})"
                    },
                    {
                      "value": "__item.quantityB",
                      "text": "Quantity B\\nB الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item.fg.0}},fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.order.product.packingMode.0.unit2}}), ,{{__item.order.product.packingMode.0.unit2}})"
                    },
                    {
                      "value": "__item.quantityC",
                      "text": "Quantity C\\nC الكمية",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(LENGTH,{{__item.order.product.packingMode}}),>,1),fn(CONCAT,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.factoryTicket.order}},{{__item.fg.0}},fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.order.product.packingMode.1.unit2}}), ,{{__item.order.product.packingMode.1.unit2}}),fn(CONCAT,N/A))"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Calloff Table",
                  "disabled": "FALSE",
                  "items": "fetchedData.loadingManifest.data.callOffs",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.loadingManifest.data.callOffs}}),&&,fn(NOT,fn(LENGTH,{{fetchedData.formattedOrders}})))",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.loadingManifest.data.callOffs}}))"
                    },
                    {
                      "value": "__item.callOff._id",
                      "text": "Order #\\n# حزمة"
                    },
                    {
                      "value": "__item.callOff.product",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productInvoiceName,fn(HELPER_FN,productAlias,{{__item.callOff.product}}),{{__item.lineNumber}},{{__item.itemNumber}})"
                    },
                    {
                      "value": "__item.quantityA",
                      "text": "Quantity A\\nA الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.callOff.product}},{{__item.callOff.product.packingMode.0.unit1}}), ,{{__item.callOff.product.packingMode.0.unit1}})"
                    },
                    {
                      "value": "__item.quantityB",
                      "text": "Quantity B\\nB الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.callOff.product}},{{__item.callOff.product.packingMode.0.unit2}}), ,{{__item.callOff.product.packingMode.0.unit2}})"
                    },
                    {
                      "value": "__item.quantityC",
                      "text": "Quantity C\\nC الكمية",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(LENGTH,{{__item.callOff.product.packingMode}}),>,1),fn(CONCAT,fn(HELPER_FN,convertSellingUnitQuantity,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.callOff.product}},{{__item.callOff.product.packingMode.1.unit2}}), ,{{__item.callOff.product.packingMode.1.unit2}}),fn(CONCAT,N/A))"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Calloff Orders Table",
                  "disabled": "FALSE",
                  "items": "fetchedData.formattedOrders",
                  "showIf": "fn(LENGTH,{{fetchedData.formattedOrders}})",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "url",
                      "url": "/order/{{__item.order}}"
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل"
                    },
                    {
                      "value": "quantityA",
                      "text": "Quantity A\\nA الكمية"
                    },
                    {
                      "value": "__item.quantityB",
                      "text": "Quantity B\\nB الكمية"
                    },
                    {
                      "value": "__item.quantityC",
                      "text": "Quantity C\\nC الكمية"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestShippingDetails",
                  "variable": "fetchedData.loadingManifest.data",
                  "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.orders}})",
                  "label": "Shipping Details",
                  "config": {
                    "deliveryAddressRefVariable": "orders.0.order.deliveryLocation"
                  }
                }
              ]
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestShippingDetails",
                  "variable": "fetchedData.loadingManifest.data",
                  "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.callOffs}})",
                  "label": "Shipping Details",
                  "config": {
                    "deliveryAddressRefVariable": "callOffs.0.callOff.deliveryLocation"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.loadingManifest.data.proofOfDelivery",
                  "disabled": "true",
                  "showIf": "fn(NOT,fn(NOT,{{fetchedData.loadingManifest.data.proofOfDelivery.0.picture}}))",
                  "printable": false,
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Proof Of Delivery",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "standard"
                        }
                      ]
                    }
                  ]
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.proofOfDelivery}})"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.loadingManifest.data.invoice}},>,0)",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Mark As Dispatched",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifest.data.status}},'),==,'Invoiced')",
                  "color": "primary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyLmDispatchDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getLmDispatchDetails",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.dispatchForm",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyLmDispatchDetails"
                    },
                    {
                      "executionOrder": 2,
                      "name": "openDispatchPopup",
                      "pageFunction": {
                        "name": "openDispatchPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Mark As Dispatched"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Mark As Delivered",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifest.data.status}},'),==,'Dispatched')",
                  "color": "primary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openDeliveryPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Mark As Delivered"
                      },
                      "name": "openDeliveryPopup"
                    }
                  ]
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update POD",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifest.data.status}},'),==,'Delivered')",
                  "color": "primary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openUpdateDeliveryPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Update POD"
                      },
                      "name": "openUpdateDeliveryPopup"
                    }
                  ]
                }
              ],
              "showIf": "{{fetchedData.allowPODUpdate}}"
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Mark As Dispatched",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.dispatchForm.typeOfDelivery",
                  "label": "Type of Delivery",
                  "disabled": "FALSE",
                  "items": "[\"Senddex\",\"Aramex\",\"Naqel\",\"Smsa\",\"Company Driver\",\"Third Party\",\"Customer Pickup\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.dispatchForm.trackingNo",
                  "label": "Tracking No",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.dispatchForm.driverName",
                  "label": "Driver Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.dispatchForm.plateNumber",
                  "label": "Plate Number",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Mark As Dispatched",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "markLmAsDispatched",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/loadingmanifest/{{fetchedData.loadingManifest.data._id}}/mark-dispatched",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.dispatchForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "markLmAsDispatched"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDispatchPopup",
                  "pageFunction": {
                    "name": "closeDispatchPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Mark As Dispatched"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Mark As Delivered",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.deliveryForm.proofOfDelivery",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Proof Of Delivery",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Mark As Delivered",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "markLmAsDelivered",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/loadingmanifest/{{fetchedData.loadingManifest.data._id}}/mark-delivered",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.deliveryForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "markLmAsDelivered"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDeliveryPopup",
                  "pageFunction": {
                    "name": "closeDeliveryPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Mark As Delivered"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Update POD",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "fetchedData.deliveryForm.proofOfDelivery",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "fileupload",
                          "variable": "picture",
                          "label": "Proof Of Delivery",
                          "disabled": "FALSE",
                          "color": "primary",
                          "previewType": "no-preview"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update POD",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "updatePOD",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/loadingmanifest/{{fetchedData.loadingManifest.data._id}}/update-delivered",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.deliveryForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PATCH"
                  },
                  "name": "updatePOD"
                },
                {
                  "executionOrder": 2,
                  "name": "closePodPopup",
                  "pageFunction": {
                    "name": "closePodPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Update POD"
                  }
                }
              ]
            }
          ]
        }
      ],
      "arabicTitle": "بيان التحميل",
      "useMaxPageWidth": true,
      "printDocDate": "{{fetchedData.loadingManifest.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getLoadingManifestData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/loadingmanifest/{{__params.loadingManifestId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.loadingManifest"
        },
        "name": "getLoadingManifestData"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.loadingManifest.data.orders.0.factoryTicket.order.customer._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.customerDetails"
        },
        "name": "getCustomerDetails",
        "executeIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.orders}})"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.loadingManifest.data.callOffs.0.callOff.customer._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.customerDetails"
        },
        "name": "getCustomerDetails",
        "executeIf": "fn(LENGTH,{{fetchedData.loadingManifest.data.callOffs}})"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyFormattedOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getFormattedOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyFormattedOrders"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyLmPODUpdateFeatureFlag",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getLmPODUpdateFeatureFlag",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyLmPODUpdateFeatureFlag"
      }
    ],
    "functions": [
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "formattedOrders": "fn(HELPER_FN,formatCallOffForLoadingManifest,{{fetchedData.loadingManifest.data}})"
        },
        "useFormula": true
      },
      {
        "name": "getLmDispatchDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "typeOfDelivery": "fetchedData.loadingManifest.data.typeOfDelivery",
          "trackingNo": "fetchedData.loadingManifest.data.trackingNo",
          "driverName": "fetchedData.loadingManifest.data.driverName",
          "plateNumber": "fetchedData.loadingManifest.data.plateNumber"
        }
      },
      {
        "name": "getLmPODUpdateFeatureFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "allowPODUpdate": "fn(FEATURE_FLAG,Update Delivered LM)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,GENERAL_MANAGER",
  "visible": false
}